const SvgPromoInvalid = () => {
  return (
    <svg
      style={{ marginTop: -4 }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1819_13846)">
        <path
          d="M9 1.5C4.86452 1.5 1.5 4.86453 1.5 9C1.5 13.1355 4.86452 16.5 9 16.5C13.1355 16.5 16.5 13.1355 16.5 9C16.5 4.86453 13.1355 1.5 9 1.5ZM9 2.625C12.5275 2.625 15.375 5.47252 15.375 9C15.375 12.5275 12.5275 15.375 9 15.375C5.47252 15.375 2.625 12.5275 2.625 9C2.625 5.47252 5.47252 2.625 9 2.625ZM8.99121 4.86694C8.84215 4.86927 8.70012 4.93067 8.5963 5.03765C8.49248 5.14463 8.43536 5.28844 8.4375 5.4375V9.9375C8.43645 10.012 8.45022 10.086 8.47801 10.1552C8.50581 10.2244 8.54707 10.2873 8.59941 10.3404C8.65175 10.3935 8.71411 10.4357 8.78288 10.4644C8.85165 10.4932 8.92545 10.508 9 10.508C9.07455 10.508 9.14835 10.4932 9.21712 10.4644C9.28589 10.4357 9.34825 10.3935 9.40059 10.3404C9.45293 10.2873 9.49419 10.2244 9.52199 10.1552C9.54978 10.086 9.56355 10.012 9.5625 9.9375V5.4375C9.56358 5.36221 9.54953 5.28748 9.5212 5.21772C9.49286 5.14796 9.45081 5.0846 9.39753 5.03139C9.34426 4.97818 9.28084 4.93621 9.21105 4.90796C9.14125 4.87972 9.0665 4.86577 8.99121 4.86694ZM9 11.625C8.80109 11.625 8.61032 11.704 8.46967 11.8447C8.32902 11.9853 8.25 12.1761 8.25 12.375C8.25 12.5739 8.32902 12.7647 8.46967 12.9053C8.61032 13.046 8.80109 13.125 9 13.125C9.19891 13.125 9.38968 13.046 9.53033 12.9053C9.67098 12.7647 9.75 12.5739 9.75 12.375C9.75 12.1761 9.67098 11.9853 9.53033 11.8447C9.38968 11.704 9.19891 11.625 9 11.625Z"
          fill="#EB5757"
        />
      </g>
      <defs>
        <clipPath id="clip0_1819_13846">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgPromoInvalid;
